import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    IconButton,
    Box,
    Button
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const TypeSelectorDialog = ({ open, onClose, types, parentProduct, onAddToCart, showCount, quantityField }) => {
    const [quantities, setQuantities] = useState({});

    const handleChange = (id, delta) => {
        setQuantities(prev => {
            const newQty = Math.max((prev[id] || 0) + delta, 0);
            return { ...prev, [id]: newQty };
        });
    };

    const handleConfirm = () => {
        types.forEach(type => {
            const qty = quantities[type.id] || 0;
            if (qty > 0) onAddToCart(type, qty);
        });
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
            <DialogTitle>{parentProduct.name} turlari</DialogTitle>
            <DialogContent>
                {types.map(type => {
                    const qtyVal = type?.[quantityField];
                    return (
                        <Box
                            key={type.id}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mb={2}
                        >
                            <Box>
                                <Typography>{type.name}</Typography>
                                {/* offCount=true bo‘lsa TYPE miqdorini ham ko‘rsatamiz */}
                                {showCount && (
                                    <Typography variant="caption" color="text.secondary">
                                        Miqdori: {Number(qtyVal ?? 0).toLocaleString()}
                                    </Typography>
                                )}
                                <Typography variant="caption">
                                    {Number(type.price || 0).toLocaleString()} so'm
                                </Typography>
                            </Box>
                            <Box display="flex" alignItems="center">
                                <IconButton onClick={() => handleChange(type.id, -1)}><RemoveIcon /></IconButton>
                                <Typography>{quantities[type.id] || 0}</Typography>
                                <IconButton onClick={() => handleChange(type.id, 1)}><AddIcon /></IconButton>
                            </Box>
                        </Box>
                    );
                })}
                <Button variant="contained" onClick={handleConfirm} fullWidth>
                    Tanlash
                </Button>
            </DialogContent>
        </Dialog>
    );
};

export default TypeSelectorDialog;
